import { render, staticRenderFns } from "./SearchPageHotelCardRightBlock.vue?vue&type=template&id=2af4d21f&scoped=true&"
import script from "./SearchPageHotelCardRightBlock.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchPageHotelCardRightBlock.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchPageHotelCardRightBlock.vue?vue&type=style&index=0&id=2af4d21f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af4d21f",
  null
  
)

export default component.exports